import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import { useTheme } from 'styled-components';
const NextStepsAnimation = '/images/animations/reprofiling/next-steps.riv';
import { ReactComponent as Target } from 'src/images/svgs/reprofiling/target.svg';
import { StyledContainer, StyledContentPanel, StyledGreeting, StyledMainContent, StyledMainText, StyledMainTextRow, StyledMainTextSection, StyledRiveWrapper, StyledStarIcon, StyledSubtext, StyledTopPanel } from './start.styles';
export const ReprofilingStart = ({
  name = ''
}: {
  name?: string;
}) => {
  const styledTheme = useTheme();
  const {
    RiveComponent
  } = useRive({
    src: NextStepsAnimation,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
      layoutScaleFactor: 1,
      alignment: Alignment.TopCenter
    })
  });
  const formatName = (name: string) => {
    if (!name) return '';
    return name.split('.').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('.');
  };
  const formattedName = formatName(name);
  return <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="ReprofilingStart" data-sentry-source-file="start.tsx">
      <StyledTopPanel data-sentry-element="StyledTopPanel" data-sentry-source-file="start.tsx">
        <StyledStarIcon data-sentry-element="StyledStarIcon" data-sentry-source-file="start.tsx" />
        <StyledRiveWrapper data-sentry-element="StyledRiveWrapper" data-sentry-source-file="start.tsx">{RiveComponent && <RiveComponent />}</StyledRiveWrapper>
      </StyledTopPanel>
      <StyledContentPanel data-sentry-element="StyledContentPanel" data-sentry-source-file="start.tsx">
        <StyledMainContent data-sentry-element="StyledMainContent" data-sentry-source-file="start.tsx">
          <StyledGreeting data-sentry-element="StyledGreeting" data-sentry-source-file="start.tsx">
            Hey, <span>{formattedName}</span>!
          </StyledGreeting>
          <StyledMainTextSection data-sentry-element="StyledMainTextSection" data-sentry-source-file="start.tsx">
            <StyledMainTextRow data-sentry-element="StyledMainTextRow" data-sentry-source-file="start.tsx">
              <Target fill={styledTheme.colors.success.secondary} data-sentry-element="Target" data-sentry-source-file="start.tsx" />
              <StyledMainText data-sentry-element="StyledMainText" data-sentry-source-file="start.tsx">Zero in on Your Next Steps</StyledMainText>
            </StyledMainTextRow>
            <StyledSubtext data-sentry-element="StyledSubtext" data-sentry-source-file="start.tsx">
              Help us understand your current level and role so we can aim recommendations where they’ll make the
              biggest impact and accelerate your progress.
            </StyledSubtext>
          </StyledMainTextSection>
        </StyledMainContent>
      </StyledContentPanel>
    </StyledContainer>;
};